export class VatImportSettings {
    reverseVatSaldoOrder = false;
    skipHistoricalVatSaldoData = false;
    automaticVatImport = false;

    deserialize(data: any): this {
        this.reverseVatSaldoOrder = data?.reverse_vat_saldo_order ?? false;
        this.skipHistoricalVatSaldoData = data?.skip_historical_vat_saldo_data ?? false;
        this.automaticVatImport = data?.automatic_vat_import ?? false;
        return this;
    }

    serialize(): any {
        return {
            'reverse_vat_saldo_order': this.reverseVatSaldoOrder,
            'skip_historical_vat_saldo_data': this.skipHistoricalVatSaldoData,
            'automatic_vat_import': this.automaticVatImport,
        };
    }
}
